import React from "react";

export function DockIcon() {
  return (
    <svg
      width="28"
      height="51"
      viewBox="0 0 28 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.875 50.4167H20.625C21.8854 50.4167 22.9167 49.3854 22.9167 48.125C22.9167 46.8646 21.8854 45.8333 20.625 45.8333H6.875C5.61458 45.8333 4.58333 46.8646 4.58333 48.125C4.58333 49.3854 5.61458 50.4167 6.875 50.4167ZM22.9167 0.0229166L4.58333 0C2.0625 0 0 2.0625 0 4.58333V36.6667C0 39.1875 2.0625 41.25 4.58333 41.25H22.9167C25.4375 41.25 27.5 39.1875 27.5 36.6667V4.58333C27.5 2.0625 25.4375 0.0229166 22.9167 0.0229166ZM22.9167 32.0833H4.58333V9.16667H22.9167V32.0833Z"
        fill="white"
        fillOpacity="0.3"
      />
    </svg>
  );
}
